<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-3">
        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[10][2]"/></label>
          <div class="col-7">
            <p class="form-control-static"><trans-text i18nKey="ui['9'][25]" :replaceData="{money:3500}" /></p>
           </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.card_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[10][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Yamada Taro" v-model.trim="input.card_name" @change="$v.input.card_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <!--<input-feedback :validate-for-input="$v.input.card_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][1]"/></input-feedback>-->
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.card_no.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[10][6]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="12345678" v-model.trim="input.card_no" @change="$v.input.card_no.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <!--<input-feedback :validate-for-input="$v.input.card_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][1]"/></input-feedback>-->
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.card_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[10][7]"/>(<trans-text i18nKey="ui[10][9]"/>/<trans-text i18nKey="ui[10][8]"/>)</label>
          <div class="col-7">

            <select class="custom-select mb-2 mr-3">
              <option v-for="n of 20">{{ thisYear + n }}</option>
            </select>

            <select class="custom-select mb-2">
              <option v-for="n of 12">{{n}}</option>
            </select>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <!--<input-feedback :validate-for-input="$v.input.card_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][1]"/></input-feedback>-->
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <!--<button type="button" class="btn w-100 btn-lg btn-warning" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[13][8]"/></button>-->
              <button type="button" class="btn w-100 btn-lg btn-danger" @click="tryForm"><trans-text i18nKey="ui[10][10]"/></button>
            </div>
          </div>
        </div>
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'mypage::event::order_confirm', params:{} }">
                <trans-text i18nKey="ui[10][11]"/>
              </router-link>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {
        input: {
            card_name:'',
            card_no:'',
            card_validity_period_year:'',
            card_validity_period_month:'',
        }
      }
    },
    validations: {
      input: {
        card_name: {
//          required
        },
        card_no: {
//          required
        },
      },
    },
    created(){
    },
    computed:{
        thisYear(){
          let now = new Date();
          return Number(now.getFullYear());
        }

    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PageForm.vue?9d9b75da